import { Col, Row } from 'antd';
import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  IntegrationHeader,
  PageContent,
} from 'components/organisms/module-settings/integrations/components';
import { SettingsPage } from 'routes/settings/setting-page-layout-style';

interface IntegrationPageTemplateProps {
  title: string;
  icon?: ReactNode;
  breadcrumbLink?: string;
  breadcrumbText?: string;
  subText?: string;
  learnMoreLink?: string;
  disableBreadcrumb?: boolean;
}

export const IntegrationPageTemplate: FC<
  React.PropsWithChildren<IntegrationPageTemplateProps>
> = ({
  title,
  icon,
  breadcrumbLink,
  breadcrumbText,
  children,
  subText,
  learnMoreLink,
  disableBreadcrumb,
}) => {
  return (
    <SettingsPage>
      <IntegrationHeader
        disableBreadcrumb={disableBreadcrumb}
        title={title}
        icon={icon}
        breadcrumbLink={breadcrumbLink}
        breadcrumbText={breadcrumbText}
        subText={subText}
        learnMoreLink={
          learnMoreLink ? (
            <a href={learnMoreLink} target="_blank" rel="noreferrer">
              <FormattedMessage id="learn_more_with_dots" />
            </a>
          ) : null
        }
      />
      <PageContent>
        <Row>
          <Col xl={{ span: 16, offset: 4 }} span={16} offset={4}>
            {children}
          </Col>
        </Row>
      </PageContent>
    </SettingsPage>
  );
};
